/* tslint:disable */
/* eslint-disable */
/**
 * Lumen Failure Management API
 * <h5>ToDo: API description</h5>
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface RefreshTokenVm
 */
export interface RefreshTokenVm {
    /**
     * 
     * @type {string}
     * @memberof RefreshTokenVm
     */
    token?: string;
    /**
     * 
     * @type {Date}
     * @memberof RefreshTokenVm
     */
    expires?: Date;
}

export function RefreshTokenVmFromJSON(json: any): RefreshTokenVm {
    return RefreshTokenVmFromJSONTyped(json, false);
}

export function RefreshTokenVmFromJSONTyped(json: any, ignoreDiscriminator: boolean): RefreshTokenVm {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'token': !exists(json, 'token') ? undefined : json['token'],
        'expires': !exists(json, 'expires') ? undefined : (new Date(json['expires'])),
    };
}

export function RefreshTokenVmToJSON(value?: RefreshTokenVm | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'token': value.token,
        'expires': value.expires === undefined ? undefined : (value.expires.toISOString()),
    };
}


